import { Offcanvas, Form } from "react-bootstrap";
import CustomButton from "../../components/CustomButton/CustomButton";
import { useForm } from "react-hook-form";
import ReactQuill from "react-quill-new";
import { useEffect, useState } from "react";
import WebService from "../../utility/WebService";
import { toast } from "react-toastify";
import moment from "moment";

interface EventFormData {
  show: boolean;
  handleClose: () => void;
  data?: any;
}

type FormData = {
  name: string;
  type: string;
};

const AddTag = ({ show, handleClose, data }: EventFormData) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    watch,
  } = useForm<FormData>();
  const [value, setValue] = useState("");
  const [isLoading, setLoading] = useState(false);
  const [file, setFile] = useState<File | null>(null);
  // ✅ Dropdown options with different id and label
  const tagTypes = [
    { id: "NEWS", label: "News" },
    // { id: "BLOG", label: "Blog" },
    // { id: "GALLERY", label: "Gallery" },
    { id: "INDUSTRY_REPORT", label: "Industry Report" },
    { id: "TENDERS", label: "Tenders" },
    { id: "PRESENTATION", label: "Presentation" },
    { id: "KNW_PAPER", label: "Monthly Report" },
    { id: "RESOURCE_INDEX", label: "Index" },
    { id: "WORKING_GROUP", label: "Working Group" },
    { id: "REGULATION", label: "Representations" },
    { id: "EVENT", label: "Event" },
    // { id: "HOME", label: "Home" },
  ];
  useEffect(() => {
    if (data) {
      reset({
        name: data.name || "",
        type: data.type || "",
      });
    } else {
      reset({});
      setValue("");
    }
  }, [show]);

  const onSubmit = (request: FormData) => {
    setLoading(true);
    const formData = new FormData();
    formData.append("name", request.name);
    formData.append("type", request.type);

    if (data?._id) {
      WebService.fileUploadPutAPI({
        action: `tags/edit/${data._id}`,
        body: formData,
      })
        .then((res: any) => {
          toast.success(res.message);
          reset();
          handleClose();
          setFile(null);
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
          toast.error(error.response?.data?.message || "An error occurred");
        });
    } else {
      WebService.fileUploadAPI({
        action: `tags/add`,
        body: formData,
      })
        .then((res: any) => {
          toast.success(res.message);
          reset();
          handleClose();
          setFile(null);
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
          toast.error(error.response?.data?.message || "An error occurred");
        });
    }
  };

  return (
    <>
      <Offcanvas
        show={show}
        onHide={() => {
          reset();
          setFile(null);
          handleClose();
        }}
        placement="end"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{data ? "Edit Tag" : "Add Tag"}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Form>
            <Form.Group className="mb-2" controlId="eventName">
              <Form.Label className="label">
                Name <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter name"
                {...register("name", { required: "Name is required" })}
              />
              {errors.name && (
                <div className="error-message">{errors.name.message}</div>
              )}
            </Form.Group>

            {/* Tag Type Dropdown */}
            {/* Tag Type Dropdown */}
            <Form.Group className="mb-3" controlId="tagType">
              <Form.Label className="label">
                Type <span className="text-danger">*</span>
              </Form.Label>
              <Form.Select
                {...register("type", { required: "Type is required" })}
              >
                <option value="">Select Type</option>
                {tagTypes.map((type) => (
                  <option key={type.id} value={type.id}>
                    {type.label}
                  </option>
                ))}
              </Form.Select>
              {errors.type && (
                <div className="error-message">{errors.type.message}</div>
              )}
            </Form.Group>
          </Form>
        </Offcanvas.Body>
        <div className="d-flex justify-content-end p-3">
          <CustomButton
            isLoading={isLoading}
            label="Save"
            className="w-100"
            onClick={handleSubmit(onSubmit)}
          />
        </div>
      </Offcanvas>
    </>
  );
};

export default AddTag;
